import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface GlobalSearchResult {
  type: 'page' | 'doc';
  label: string;
  route: string;
}

export interface GlobalSearchResponse {
  results: GlobalSearchResult[];
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  constructor(private readonly http: HttpClient) {}

  search(query: string): Observable<GlobalSearchResponse> {
    const params = new HttpParams().set('q', query);
    return this.http.get<GlobalSearchResponse>(`${environment.apiUrl}/auth/search/`, { params });
  }
}
